const Portfolio =
{
  portfolio1     :
  {
    id          : 1,
    links       : 
    {
      main      : 'https://builten360.web.app/parquesdegirona'
    },
    info        :
    {
      name      : 'Parques de Miranda',
      type      : 'Casa Modelo'
    },
    credits     :
    {
      construction  :
      {
        investors   : 'pmjarquitectos',
        builder     : 'pmjarquitectos',
        decor       : ''
      },
      design    :
      {
        architectural     : '',
        structural        : 'entornoceo',
        electric          : '',
        lighting          : 'lightitbe',
        hidraulic         : '',
        decor             : '',
        interior          : ''
      },
      labor  :
      {

      }, 
      materiales  :
      {

      },
      images      :
      {
        photo     : 'entornoceo',
        render    : ''
      }
    },

    tour        : 'tour18',    
  },

  portfolio2     :
  {
    id          : 2,
    links       : 
    {
      main      : 'https://builten360.web.app/parquesdegirona'
    },
    info        :
    {
      name      : 'Parques de Miranda',
      type      : 'Construcción'
    },
    credits     :
    {
      construction  :
      {
        investors   : 'pmjarquitectos',
        builder     : 'pmjarquitectos',
        decor       : ''
      },
      design    :
      {
        architectural     : '',
        structural        : 'entornoceo',
        electric          : '',
        lighting          : 'lightitbe',
        hidraulic         : '',
        decor             : '',
        interior          : ''
      },
      labor  :
      {

      }, 
      materiales  :
      {

      },
      images      :
      {
        photo     : 'entornoceo',
        render    : ''
      }
    },

    tour        : 'tour6',    
  },

  portfolio3     :
  {
    id          : 3,
    links       : 
    {
      main      : 'https://builten360.web.app/parquesdegirona'
    },
    info        :
    {
      name      : 'Parques de Miranda',
      type      : 'Desarrollo'
    },
    credits     :
    {
      construction  :
      {
        investors   : 'pmjarquitectos',
        builder     : 'pmjarquitectos',
        decor       : ''
      },
      design    :
      {
        architectural     : '',
        structural        : 'entornoceo',
        electric          : '',
        lighting          : 'lightitbe',
        hidraulic         : '',
        decor             : '',
        interior          : ''
      },
      labor  :
      {

      }, 
      materiales  :
      {

      },
      images      :
      {
        photo     : '',
        render    : 'entornoceo'
      }
    },

    tour        : 'tour7',    
  },

  portfolio4     :
  {
    id          : 4,
    links       : 
    {
      main      : 'https://builten360.web.app/parquesdegirona'
    },
    info        :
    {
      name      : 'Azariah',
      type      : 'Concepto'
    },
    credits     :
    {
      construction  :
      {
        investors   : 'pmjarquitectos',
        builder     : 'arbuconstructora',
        decor       : ''
      },
      design    :
      {
        architectural     : '',
        structural        : 'entornoceo',
        electric          : '',
        lighting          : 'lightitbe',
        hidraulic         : '',
        decor             : '',
        interior          : ''
      },
      labor  :
      {

      }, 
      materiales  :
      {

      },
      images      :
      {
        photo     : 'entornoceo',
        render    : ''
      }
    },

    tour        : 'tour8',    
  },

  portfolio5     :
  {
    id          : 5,
    links       : 
    {
      main      : 'https://builten360.web.app/parquesdegirona'
    },
    info        :
    {
      name      : 'Parques de Galicia 2',
      type      : 'Vía'
    },
    credits     :
    {
      construction  :
      {
        investors   : 'pmjarquitectos',
        builder     : 'pmjarquitectos',
        decor       : ''
      },
      design    :
      {
        architectural     : '',
        structural        : 'entornoceo',
        electric          : '',
        lighting          : 'lightitbe',
        hidraulic         : '',
        decor             : '',
        interior          : ''
      },
      labor  :
      {

      }, 
      materiales  :
      {

      },
      images      :
      {
        photo     : 'entornoceo',
        render    : ''
      }
    },

    tour        : 'tour4',    
  }, 

  portfolio6     :
  {
    id          : 6,
    links       : 
    {
      main      : 'https://builten360.web.app/parquesdegirona'
    },
    info        :
    {
      name      : 'Parques de Galicia 2',
      type      : 'Casa Modelo'
    },
    credits     :
    {
      construction  :
      {
        investors   : 'pmjarquitectos',
        builder     : 'pmjarquitectos',
        decor       : ''
      },
      design    :
      {
        architectural     : '',
        structural        : 'entornoceo',
        electric          : '',
        lighting          : 'lightitbe',
        hidraulic         : '',
        decor             : '',
        interior          : ''
      },
      labor  :
      {

      }, 
      materiales  :
      {

      },
      images      :
      {
        photo     : 'entornoceo',
        render    : ''
      }
    },

    tour        : 'tour16',    
  },

  portfolio7     :
  {
    id          : 7,
    links       : 
    {
      main      : 'https://builten360.web.app/parquesdegirona'
    },
    info        :
    {
      name      : 'Parques de Galicia 2',
      type      : 'Casa Modelo'
    },
    credits     :
    [
      {
        category  : 'construction',
        type      : 'builder',
        userName  : 'pmjarquitectos',
        userID    : 1,
      },
      {
        category  : 'design',
        type      : 'architectural',
        userName  : 'entornoceo',
        userID    : 4,
      },
      {
        category  : 'design',
        type      : 'lighting',
        userName  : 'lightitbe',
        userID    : 2,
      },
      {
        category  : 'images',
        type      : 'photo',
        userName  : 'entornoceo',
        userID    : 4,
      },
  ] ,

    tour        : 'tour16',    
  }, 
}

export default Portfolio;